import styled, { css } from 'styled-components';

export const Card = styled.a`
  display: flex;
  width: 100%;
  max-width: 262px;
  height: 100%;
  align-items: center;
  justify-content: center;
  padding: 8px;
  margin: 2px;
  border-radius: 5px;
  border: 1px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  cursor: pointer;

  ${(props) =>
    props.small &&
    css`
      max-width: 131px;
    `}

  &:hover {
    box-shadow: 0 0 0 2px ${(props) => props.theme.borderColor};
  }
`;

export const CardInner = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  text-align: center;
`;

export const ImageHolder = styled.div`
  position: relative;
  display: grid;
  width: 100%;
  height: 60%;
  min-height: 152px;
  margin-bottom: 12px;
  border-radius: 3px;
  overflow: hidden;
  background: ${(props) => props.theme.background};
`;

export const Image = styled.img`
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Video = styled.video`
  position: absolute;
  display: block;
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const VideoIcon = styled.i`
  position: absolute;
  bottom: 5px;
  right: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.color};
  font-size: 33px;
`;

export const Placeholder = styled.i`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  font-size: 72px;
`;

export const Details = styled.div`
  display: grid;
  width: 100%;
  grid-gap: 6px;
`;

export const Detail = styled.span`
  display: inline-block;
  width: 100%;
  color: ${(props) => props.theme.color};
  font-size: 12px;
  font-weight: 700;
  line-height: 1;
  text-align: left;
`;

export const DetailLabel = styled.span`
  display: inline;
  width: auto;
  color: ${(props) => props.theme.color};
`;

export const Labels = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: auto;
  margin: 10px -5px 0;
`;

export const Label = styled.span`
  display: inline-flex;
  margin: 5px;
  padding: 4px 8px 5px;
  border-radius: 5px;
  color: ${(props) => props.theme.color};
  background: ${(props) => props.theme.background};
  font-size: 15px;
  font-weight: 500;
  line-height: 1;
  word-break: break-word;
`;

export const Selection = styled.span`
  position: absolute;
  top: 5px;
  left: 5px;
  display: block;
  height: 25px;
  width: 25px;
  -webkit-appearance: none;
  -moz-appearance: none;
  -o-appearance: none;
  appearance: none;
  border: 2px solid ${(props) => props.theme.border};
  background: ${(props) => props.theme.background};
  border-radius: 2px;
  outline: none;

  ${(props) =>
    props.selected &&
    css`
      border: 2px solid ${(props) => props.theme.borderOnCheckmark};
      background: ${(props) => props.theme.backgroundOnCheckmark};
    `}
`;

export const SelectionInput = styled.input`
  position: absolute;
  top: 0;
  left: 0;
  display: block;
  height: 25px;
  width: 25px;
  opacity: 0;
`;

export const SelectionCheckmark = styled.span`
  position: absolute;
  top: 50%;
  left: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 25px;
  width: 25px;
  transform: translate(-50%, -50%);
  opacity: 0;
  font-size: 12px;
  font-weight: 700;
  line-height: 1.2;
  cursor: pointer;

  ${(props) =>
    props.selected &&
    css`
      opacity: 1;
      color: ${(props) => props.theme.colorOnCheckmark};
    `}
`;

export const Icon = styled.i`
  position: absolute;
  right: 5px;
  top: 5px;
  display: block;
  color: ${(props) => props.theme.color};
  font-size: 24px;
  cursor: pointer;

  &:hover {
    color: ${(props) => props.theme.colorHover};
  }
`;
